/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserRankData } from './UserRankData';
import {
    UserRankDataFromJSON,
    UserRankDataFromJSONTyped,
    UserRankDataToJSON,
    UserRankDataToJSONTyped,
} from './UserRankData';

/**
 * 
 * @export
 * @interface TopLeaderboardRanksResponse
 */
export interface TopLeaderboardRanksResponse {
    /**
     * 
     * @type {Array<UserRankData>}
     * @memberof TopLeaderboardRanksResponse
     */
    users: Array<UserRankData>;
    /**
     * Total number of ranked users (with XP > 0)
     * @type {number}
     * @memberof TopLeaderboardRanksResponse
     */
    total: number;
}

/**
 * Check if a given object implements the TopLeaderboardRanksResponse interface.
 */
export function instanceOfTopLeaderboardRanksResponse(value: object): value is TopLeaderboardRanksResponse {
    if (!('users' in value) || value['users'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function TopLeaderboardRanksResponseFromJSON(json: any): TopLeaderboardRanksResponse {
    return TopLeaderboardRanksResponseFromJSONTyped(json, false);
}

export function TopLeaderboardRanksResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TopLeaderboardRanksResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'users': ((json['users'] as Array<any>).map(UserRankDataFromJSON)),
        'total': json['total'],
    };
}

export function TopLeaderboardRanksResponseToJSON(json: any): TopLeaderboardRanksResponse {
    return TopLeaderboardRanksResponseToJSONTyped(json, false);
}

export function TopLeaderboardRanksResponseToJSONTyped(value?: TopLeaderboardRanksResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'users': ((value['users'] as Array<any>).map(UserRankDataToJSON)),
        'total': value['total'],
    };
}

